// import { useState } from 'react';
// import { Link } from 'react-router-dom';
// import { useUI } from '../../context/UIContext';
// import { subscribeNewsletter } from '../../lib/api';

// export default function Footer() {
//   const { openEnquiry } = useUI();
//   const [email, setEmail]   = useState('');
//   const [status, setStatus] = useState('idle');

//   async function handleSubscribe(e) {
//     e.preventDefault();
//     if (!email) return;
//     setStatus('loading');
//     try {
//       await subscribeNewsletter(email);
//       setStatus('ok');
//       setEmail('');
//     } catch {
//       setStatus('err');
//     }
//   }

//   const linkStyle = {
//     display: 'block', fontSize: 12, color: 'rgba(255,255,255,0.4)',
//     transition: 'color 0.2s', marginBottom: 10, background: 'none', border: 'none', cursor: 'pointer',
//     padding: 0, fontFamily: 'var(--font-body)', textAlign: 'left',
//   };

//   return (
//     <footer style={{ background: 'var(--dark)', color: '#fff', paddingTop: 64, paddingBottom: 32 }}>
//       <div style={{ maxWidth: 1440, margin: '0 auto', padding: '0 40px' }}>
//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 48, marginBottom: 56 }}>

//           {/* Brand */}
//           <div>
//             <div style={{ fontFamily: 'var(--font-display)', fontSize: 24, fontWeight: 300, letterSpacing: '0.2em', textTransform: 'uppercase', color: '#fff', marginBottom: 4 }}>Aurora</div>
//             <div style={{ fontSize: 10, letterSpacing: '0.3em', textTransform: 'uppercase', color: 'var(--gold)', fontWeight: 600, marginBottom: 20 }}>Luxury India</div>
//             <p style={{ fontSize: 12, lineHeight: 1.8, color: 'rgba(255,255,255,0.35)', maxWidth: 240 }}>
//               Curating the world's finest authentic luxury, delivered seamlessly to your doorstep across India.
//             </p>
//           </div>

//           {/* Collection */}
//           <div>
//             <h4 style={{ fontSize: 10, letterSpacing: '0.2em', textTransform: 'uppercase', color: '#fff', fontWeight: 600, marginBottom: 20 }}>The Collection</h4>
//             {[['New Arrivals', '/shop'], ['Handbags', '/shop?cat=Handbags'], ['Wallets', '/shop?cat=Wallets'], ['Accessories', '/shop?cat=Accessories']].map(([label, href]) => (
//               <Link key={label} to={href} style={linkStyle}
//                 onMouseEnter={e => e.target.style.color = '#fff'}
//                 onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.4)'}>{label}</Link>
//             ))}
//           </div>

//           {/* Designers */}
//           <div>
//             <h4 style={{ fontSize: 10, letterSpacing: '0.2em', textTransform: 'uppercase', color: '#fff', fontWeight: 600, marginBottom: 20 }}>Designers</h4>
//             {['Louis Vuitton', 'Chanel', 'Gucci', 'Hermès', 'Prada'].map(b => (
//               <Link key={b} to={`/shop?brand=${encodeURIComponent(b)}`} style={linkStyle}
//                 onMouseEnter={e => e.target.style.color = '#fff'}
//                 onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.4)'}>{b}</Link>
//             ))}
//             <Link to="/brands" style={{ ...linkStyle, color: 'var(--gold)' }}
//               onMouseEnter={e => e.target.style.color = '#fff'}
//               onMouseLeave={e => e.target.style.color = 'var(--gold)'}>View All →</Link>
//           </div>

//           {/* Services + Newsletter */}
//           <div>
//             <h4 style={{ fontSize: 10, letterSpacing: '0.2em', textTransform: 'uppercase', color: '#fff', fontWeight: 600, marginBottom: 20 }}>Client Services</h4>
//             <Link to="/about" style={linkStyle}
//               onMouseEnter={e => e.target.style.color = '#fff'}
//               onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.4)'}>The House</Link>
//             <button onClick={openEnquiry} style={linkStyle}
//               onMouseEnter={e => e.target.style.color = '#fff'}
//               onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.4)'}>Request a Piece</button>
//             <Link to="/wishlist" style={linkStyle}
//               onMouseEnter={e => e.target.style.color = '#fff'}
//               onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.4)'}>My Wishlist</Link>
//             {/* <Link to="/blogs" style={linkStyle}
//               onMouseEnter={e => e.target.style.color = '#fff'}
//               onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.4)'}>Journal</Link> */}

//             {/* Newsletter */}
//             <div style={{ marginTop: 28 }}>
//               <p style={{ fontSize: 10, letterSpacing: '0.15em', textTransform: 'uppercase', color: '#fff', fontWeight: 600, marginBottom: 12 }}>Newsletter</p>
//               <form onSubmit={handleSubscribe} style={{ display: 'flex', gap: 0 }}>
//                 <input
//                   type="email" value={email} onChange={e => setEmail(e.target.value)}
//                   placeholder="Your email"
//                   style={{ flex: 1, padding: '10px 12px', fontSize: 11, background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.15)', color: '#fff', outline: 'none', fontFamily: 'var(--font-body)' }}
//                 />
//                 <button type="submit" disabled={status === 'loading' || status === 'ok'} style={{
//                   padding: '10px 14px', background: 'var(--gold)', border: 'none', cursor: 'pointer',
//                   fontSize: 10, letterSpacing: '0.1em', fontWeight: 700, color: '#fff',
//                   textTransform: 'uppercase', opacity: status === 'loading' ? 0.7 : 1,
//                 }}>
//                   {status === 'ok' ? '✓' : status === 'loading' ? '…' : 'Join'}
//                 </button>
//               </form>
//               {status === 'err' && <p style={{ fontSize: 11, color: 'var(--red)', marginTop: 6 }}>Try again</p>}
//             </div>
//           </div>
//         </div>

//         <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
//           <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.25)' }}>© {new Date().getFullYear()} Aurora Luxury India. All rights reserved.</p>
//           <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.2)', textAlign: 'right' }}>Buy Authentic Luxury Bags & Accessories Online</p>
//         </div>
//       </div>
//     </footer>
//   );
// }

import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useUI } from '../../context/UIContext';
import { subscribeNewsletter } from '../../lib/api';

export default function Footer() {
  const { openEnquiry } = useUI();
  const [email, setEmail]   = useState('');
  const [status, setStatus] = useState('idle');

  async function handleSubscribe(e) {
    e.preventDefault();
    if (!email) return;
    setStatus('loading');
    try {
      await subscribeNewsletter(email);
      setStatus('ok');
      setEmail('');
    } catch {
      setStatus('err');
    }
  }

  const linkStyle = {
    display: 'block', fontSize: 12, color: 'rgba(255,255,255,0.4)',
    transition: 'color 0.2s', marginBottom: 10, background: 'none', border: 'none', cursor: 'pointer',
    padding: 0, fontFamily: 'var(--font-body)', textAlign: 'left',
  };

  return (
    <footer style={{ background: 'var(--dark)', color: '#fff', paddingTop: 64, paddingBottom: 32 }}>
      <div style={{ maxWidth: 1440, margin: '0 auto', padding: '0 40px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 48, marginBottom: 56 }}>

          {/* Brand */}
          <div>
            <div style={{ fontFamily: 'var(--font-display)', fontSize: 24, fontWeight: 300, letterSpacing: '0.2em', textTransform: 'uppercase', color: '#fff', marginBottom: 4 }}>Aurora</div>
            <div style={{ fontSize: 10, letterSpacing: '0.3em', textTransform: 'uppercase', color: 'var(--gold)', fontWeight: 600, marginBottom: 20 }}>Luxury India</div>
            <p style={{ fontSize: 12, lineHeight: 1.8, color: 'rgba(255,255,255,0.35)', maxWidth: 240 }}>
              Curating the world's finest authentic luxury, delivered seamlessly to your doorstep across India.
            </p>
          </div>

          {/* Collection */}
          <div>
            <h4 style={{ fontSize: 10, letterSpacing: '0.2em', textTransform: 'uppercase', color: '#fff', fontWeight: 600, marginBottom: 20 }}>The Collection</h4>
            {[['New Arrivals', '/shop'], ['Handbags', '/shop?cat=Handbags'], ['Wallets', '/shop?cat=Wallets'], ['Accessories', '/shop?cat=Accessories']].map(([label, href]) => (
              <Link key={label} to={href} style={linkStyle}
                onMouseEnter={e => e.target.style.color = '#fff'}
                onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.4)'}>{label}</Link>
            ))}
          </div>

          {/* Designers */}
          <div>
            <h4 style={{ fontSize: 10, letterSpacing: '0.2em', textTransform: 'uppercase', color: '#fff', fontWeight: 600, marginBottom: 20 }}>Designers</h4>
            {['Louis Vuitton', 'Chanel', 'Gucci', 'Hermès', 'Prada'].map(b => (
              <Link key={b} to={`/shop?brand=${encodeURIComponent(b)}`} style={linkStyle}
                onMouseEnter={e => e.target.style.color = '#fff'}
                onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.4)'}>{b}</Link>
            ))}
            <Link to="/brands" style={{ ...linkStyle, color: 'var(--gold)' }}
              onMouseEnter={e => e.target.style.color = '#fff'}
              onMouseLeave={e => e.target.style.color = 'var(--gold)'}>View All →</Link>
          </div>

          {/* Services + Newsletter */}
          <div>
            <h4 style={{ fontSize: 10, letterSpacing: '0.2em', textTransform: 'uppercase', color: '#fff', fontWeight: 600, marginBottom: 20 }}>Client Services</h4>
            <Link to="/about" style={linkStyle}
              onMouseEnter={e => e.target.style.color = '#fff'}
              onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.4)'}>The House</Link>
            <button onClick={openEnquiry} style={linkStyle}
              onMouseEnter={e => e.target.style.color = '#fff'}
              onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.4)'}>Request a Piece</button>
            <Link to="/wishlist" style={linkStyle}
              onMouseEnter={e => e.target.style.color = '#fff'}
              onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.4)'}>My Wishlist</Link>

            {/* Newsletter */}
            <div style={{ marginTop: 28 }}>
              <p style={{ fontSize: 10, letterSpacing: '0.15em', textTransform: 'uppercase', color: '#fff', fontWeight: 600, marginBottom: 12 }}>Newsletter</p>
              <form onSubmit={handleSubscribe} style={{ display: 'flex', gap: 0 }}>
                <input
                  type="email" value={email} onChange={e => setEmail(e.target.value)}
                  placeholder="Your email"
                  style={{ flex: 1, padding: '10px 12px', fontSize: 11, background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.15)', color: '#fff', outline: 'none', fontFamily: 'var(--font-body)' }}
                />
                <button type="submit" disabled={status === 'loading' || status === 'ok'} style={{
                  padding: '10px 14px', background: 'var(--gold)', border: 'none', cursor: 'pointer',
                  fontSize: 10, letterSpacing: '0.1em', fontWeight: 700, color: '#fff',
                  textTransform: 'uppercase', opacity: status === 'loading' ? 0.7 : 1,
                }}>
                  {status === 'ok' ? '✓' : status === 'loading' ? '…' : 'Join'}
                </button>
              </form>
              {status === 'err' && <p style={{ fontSize: 11, color: 'var(--red)', marginTop: 6 }}>Try again</p>}
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
          <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.25)' }}>© {new Date().getFullYear()} Aurora Luxury India. All rights reserved.</p>

          {/* ── Legal Links ── */}
          <div style={{ display: 'flex', gap: 24, alignItems: 'center', flexWrap: 'wrap' }}>
            <Link
              to="/terms"
              style={{ fontSize: 11, color: 'rgba(255,255,255,0.25)', textDecoration: 'none', transition: 'color 0.2s' }}
              onMouseEnter={e => e.target.style.color = 'rgba(255,255,255,0.6)'}
              onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.25)'}
            >
              Terms & Conditions
            </Link>
            <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.1)' }}>|</span>
            <Link
              to="/privacy"
              style={{ fontSize: 11, color: 'rgba(255,255,255,0.25)', textDecoration: 'none', transition: 'color 0.2s' }}
              onMouseEnter={e => e.target.style.color = 'rgba(255,255,255,0.6)'}
              onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.25)'}
            >
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}